import React from 'react';
import PropTypes from 'prop-types';
import { Spacing, Text } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import { useWhitelabelFeatures } from 'hooks/whitelabel/useWhitelabelFeatures';

const propTypes = {
  weight: PropTypes.string,
  color: PropTypes.string,
};

/**
 * GfaDisclaimer component.
 *
 * The open-ticket rules GFA shows with its exchange form. Extracted so the copy has one home: the
 * form renders it inline on the current layout, and the redesigned shell renders the same block in
 * its footer, below the form.
 *
 * It belongs to this form, not to the shell — the shell shows whatever the rendered form gives it,
 * and a brand with no rules of its own contributes none.
 *
 * @param {object} props - Component props.
 * @param {string} [props.weight] - Font weight, so each placement can match its surroundings.
 * @param {string} [props.color] - Text colour, likewise.
 * @returns {JSX.Element}
 */
const GfaDisclaimer = ({ weight = 'bold', color = undefined }) => {
  const { t } = useTranslation('exchange');
  const features = useWhitelabelFeatures();

  return (
    <Spacing size="XS" vertical>
      <Text weight={weight} color={color}>
        {' '}
        {t('disclaimer.first')}{' '}
      </Text>
      <Text weight={weight} color={color}>
        {' '}
        {t('disclaimer.second')}{' '}
      </Text>
      <Text weight={weight} color={color}>
        {' '}
        {t('disclaimer.third')}{' '}
      </Text>
      {features.JUST_ADULT_OPEN_TICKET && (
        <Text weight={weight} color={color}>
          {' '}
          {t('disclaimer.fourth')}{' '}
        </Text>
      )}
    </Spacing>
  );
};

GfaDisclaimer.propTypes = propTypes;

export default GfaDisclaimer;
